import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import ApprovedTransactions from "./ApprovedTransactions";
import PendingTransactions from "./PendingTransactions";
import RejectedTransactions from "./RejectedTransactions";

const UpgradeCredits = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const [upgradeCreditsTab, setUpgradeCreditsTab] = useState(
    tabFromUrl || "pending",
  );
  const handleTabChange = (key) => {
    setUpgradeCreditsTab(key);
    setSearchParams({ tab: key });
  };

  useEffect(() => {
    if (tabFromUrl && tabFromUrl !== upgradeCreditsTab) {
      setUpgradeCreditsTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <h1 className="mb-4">
        <strong>Upgrade Credits</strong>
      </h1>

      <Tabs
        activeKey={upgradeCreditsTab}
        onSelect={handleTabChange}
        id="upgrade-credits-transactions"
        className="mb-3"
      >
        <Tab eventKey="pending" title="Pending Transactions">
          <PendingTransactions />
        </Tab>

        <Tab eventKey="approved" title="Approved Transactions">
          <ApprovedTransactions />
        </Tab>

        <Tab eventKey="rejected" title="Rejected Transactions">
          <RejectedTransactions />
        </Tab>
      </Tabs>
    </div>
  );
};

export default UpgradeCredits;
